module.exports = __webpack_public_path__ + "img/img60.791876a0.svg";